import React from 'react'

import { connect } from "react-redux"

import { withRouter } from 'react-router' // need to use withRouter higher order component to access the routing history since the menu isn't a component contained in the current route

import { Card } from 'primereact/card'

import Table from '../components/annual-return/annual-return-table'

import { ANNUAL_RETURN_TYPE_ANNUAL, STATUS_APPROVED } from '../js/const'

import * as annualReturnActionCreators from "../actionCreators/annualReturn"
import * as appActionCreators from "../actionCreators/app"
import * as systemParameterActionCreators from "../actionCreators/systemParameter"

class AnnualReturnTable extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      selectedAnnualReturn: {}, // determines which annual return is selcted in the table. It will be highlighted
      newAnnualReturnYear: null
    }
  }

  componentDidMount() {
    //is invoked immediately after a component is mounted. 
    //Initialization that requires DOM nodes should go here. If you need to load data from a remote endpoint, this is a good place to instantiate the network request.   
    this.props.setLoading(true)
      .then(() => this.props.getAnnualReturnStartYear())
      .then(() => this.props.setLoading(false))
      .catch((error) => {
        this.props.handleError(error)
          .then(() => this.props.setLoading(false))
      })
  }

  addAnnualReturn = () => {
    let annualReturnTypeLovId = this.props.lookupCode.annualReturnTypes.find(code => code.SystemCode === ANNUAL_RETURN_TYPE_ANNUAL).CodeLovId
    let startDate = new Date(this.state.newAnnualReturnYear, 0, 1, 0, 0, 0, 0)
    let endDate = new Date(this.state.newAnnualReturnYear, 11, 31, 0, 0, 0, 0)
    let annualReturn = {
      LobbyistId: this.props.lobbyistId,
      TypeLovId: annualReturnTypeLovId,
      StartDate: startDate,
      EndDate: endDate
    }
    this.props.setLoading(true)
      .then(() => this.props.addAnnualReturn(annualReturn))
      .then(response => {
        this.props.setAjaxResponse(response)
        if (response.data.Success) {
          this.goToAnnualReturn(response.data.SuccessOutput)
        }
      })
      .then(() => this.props.setLoading(false))
      .catch((error) => this.props.handleError(error)
        .then(() => this.props.setLoading(false)))
  }

  selectAnnualReturn = e => {
    this.goToAnnualReturn(e.data)
  }

  goToAnnualReturn = annualReturn => {
    let annualReturnPart = annualReturn ? '/' + annualReturn.AnnualReturnId : ''
    this.props.history.push('/annual-return/' + this.props.lobbyistId + annualReturnPart)
    window.scrollTo(0, 0)
  }

  getAnnualReturnYearOptions = () => {
    let currentYear = new Date().getFullYear()
    let availableYearOptions = []
    if (this.props.systemParameter.annualReturnStartYear) {
      for (let i = this.props.systemParameter.annualReturnStartYear; i < currentYear; i++) {
        availableYearOptions.push({ label: i, value: i })
      }
    }

    return availableYearOptions
  }

  setNewAnnualReturnYear = annualReturnYear => this.setState({ newAnnualReturnYear: annualReturnYear })

  render() {
    // get annual returns that have been loaded for the lobbyist
    let annualReturns = this.props.annualReturn.lobbyistAnnualReturns ? this.props.annualReturn.lobbyistAnnualReturns : []
    let currentLobbyist = this.props.lobbyist.currentLobbyist ? this.props.lobbyist.currentLobbyist : {}
    let isApproved = currentLobbyist.StatusCode === STATUS_APPROVED

    let annualReturnTableProps = {
      canSave: this.props.canSave,
      annualReturns: annualReturns,
      selectAnnualReturn: this.selectAnnualReturn,
      addAnnualReturn: this.addAnnualReturn,
      selectedAnnualReturn: this.state.selectedAnnualReturn,
      annualReturnYearOptions: this.getAnnualReturnYearOptions(),
      newAnnualReturnYear: this.state.newAnnualReturnYear,
      setNewAnnualReturnYear: this.setNewAnnualReturnYear,
      isLobbyistApproved: isApproved
    }

    return (
      <Card title="Annual Returns">
        <Table {...annualReturnTableProps} />
      </Card>
    )
  }
}

const mapStateToProps = state => {
  let { annualReturn, lookupCode, systemParameter, lobbyist } = state
  return { annualReturn, lookupCode, systemParameter, lobbyist }
}

// this is how to combine actions available
const actionCreators = {
  ...annualReturnActionCreators,
  ...appActionCreators,
  ...systemParameterActionCreators
}

export default withRouter(connect(mapStateToProps, actionCreators)(AnnualReturnTable))


// WEBPACK FOOTER //
// ./src/container/AnnualReturnTable.js